/**
 * Application Constants
 * 
 * This file contains application-wide constants that can be referenced
 * across multiple components. Centralizing these values makes it easier
 * to update them when needed without having to change multiple files.
 */

// Pricing Constants
export const PRICING = {
  CONCIERGE_FEE:99.00,
  CURRENCY: 'USD',
};

// Feature Configuration
export const FEATURES = {
  // Add feature flags or configuration options here
};

// Service Names
export const SERVICES = {
  CONCIERGE_SERVICE: 'Venue Search Booking Fee',
  // Add other service names here
};

// Analytics Constants
export const ANALYTICS = {
  // Add analytics-related constants here
  EVENT_CATEGORIES: {
    ECOMMERCE: 'ecommerce',
    FORM: 'form',
    NAVIGATION: 'navigation',
  }
}; 